import { render, staticRenderFns } from "./FsLink.vue?vue&type=template&id=f7041f00"
import script from "./FsLink.vue?vue&type=script&setup=true&lang=js"
export * from "./FsLink.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports